<template>
  <b-container v-if="getUserSession()">
    <h1>Tableau de bord</h1>
    <h2 v-show="ready">Dossiers</h2>

    <b-form class="filter">
      <div class="group">
      <img src="/static/img/filter.svg" alt="Filter" id="picto-filter">
      </div>

      <div class="group">
      <label class="mr-sm-2" for="agency">Agence</label>
      <b-form-select id="agency" v-model="filterAgencies" :options="formattedAgencies" size="sm">
        <template slot="first">
          <option :value="null">Toutes les agences</option>
        </template>
      </b-form-select>
      </div>

      <div class="group">
      <label class="mr-sm-2" for="managers">Chargé d'affaire</label>
      <b-form-select v-model="filterManagers" :options="managers" size="sm" id="managers">
        <template slot="first">
          <option :value="null">Tous les chargés d'affaire</option>
        </template>
      </b-form-select>
      </div>

      <div class="group">
      <label class="mr-sm-2" for="status">Statut</label>
      <b-form-select v-model="filterStatus" size="sm" id="status">
        <template slot="first">
          <option :value="null">Tous les statuts</option>
        </template>
        <option value="open">En cours</option>
        <option value="complete">Complet</option>
      </b-form-select>
      </div>

      <div>
      <b-button variant="primary" @click="resetFilters" size="sm" id="filterResetBtn"><span id="picto-reset"></span>Réinitialiser les filtres</b-button>
      </div>
    </b-form>


    <!-- Tranche Update Table -->
      <b-table responsive
               :items="filteredSlices"
               :fields="fields"
               :per-page="perPage"
               :current-page="currentPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               show-empty
               empty-text="Aucun état actuellement"
               :busy.sync="isBusy"
               ref="dashboard">

        <!-- Enedis Case ID -->
        <template slot="enedisCaseId" slot-scope="row">
          <router-link v-if="isAdmin() || isAgent() || isAgency()" class="case-link" :to="{ name: 'caseWithSlice', params: { enedisCaseId: row.item.enedisCase.id, sliceId: row.item.id } }">{{  row.item.enedisCase.oasiceNumber }}</router-link>
          <span v-else>{{  row.item.enedisCase.oasiceNumber }}</span>
        </template>

        <!-- Progress -->
        <template slot="progress" slot-scope="row">
          <b-progress height="20px" :max="parseInt(60)" :value="parseInt(getProgressValue(row.item))" :variant="getProgressColor(row.item)" show-value></b-progress>
        </template>

        <template slot="status" slot-scope="row">
          <span :class="getStatusClass(row.item.completeDate)">{{ formatStatusText(row.item.completeDate) }}</span>
        </template>
      </b-table>

      <b-pagination
        id="pagination"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        v-show="ready">
        <template slot="first-text" slot-scope="item">
          <span class="first-link" :class="item.disabled ? 'disabled' : ''">«</span>
        </template>
        <template slot="prev-text" slot-scope="item">
          <span class="prev-link" :class="item.disabled ? 'disabled' : ''">‹</span>
        </template>
        <template slot="page" slot-scope="item">
          <span class="page" :class="item.active ? 'active' : ''">{{ item.page }}</span>
        </template>
        <template slot="next-text" slot-scope="item">
          <span class="next-link" :class="item.disabled ? 'disabled' : ''">›</span>
        </template>
        <template slot="last-text" slot-scope="item">
          <span class="last-link" :class="item.disabled ? 'disabled' : ''">»</span>
        </template>
        <template slot="ellipsis-text">
          <span class="ellipsis">...</span>
        </template>
      </b-pagination>
  </b-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import TrancheService from '../../../services/TrancheService';
  import Clone from 'clone';

  const moment = require('moment');

  export default {
    name: 'Dashboard',
    data() {
      return {
        slices: [],
        filteredSlices: [],
        perPage: 30,
        currentPage: 1,
        ready: false,
        isBusy: false,
        filter: null,
        agencies: [],
        formattedAgencies: [],
        managers: [],
        sortBy: 'progress',
        sortDesc: true,
        filterAgencies: null,
        filterManagers: null,
        filterStatus: 'open',
        progressBar: {
          days: 0,
          variant: null,
        }
      };
    },
    methods: {
      ...mapActions([
        'getMe',
        'logout',
        'fetchAgencies',
      ]),
      ...mapGetters([
        'getUserSession',
        'getTrancheStatusEnumeration',
        'getViewPortSize',
        'getAgencies',
        'isAdmin',
        'isAgent',
        'isAgency'
      ]),
      statusArchived() {
        return {
          tranche: this.getTrancheStatusEnumeration().filter(s => s.value === 'STATUS_ARCHIVED')[0].text,
        };
      },
      formatDate(date) {
        return moment(date, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
      },
      getProgressColor(slice) {
        let data = TrancheService.getProgressData(slice);
        return data.variant;
      },
      getProgressValue(slice) {
        let data = TrancheService.getProgressData(slice);
        return data.days;
      },
      getNumberOfGaps(gapHistories) {
        if (typeof gapHistories == 'undefined' || gapHistories.length == 0) {
          return 0;
        } else {
          let clonedHistories = Clone(gapHistories);
          let sortedHistories = clonedHistories.sort((a,b) => { return new Date(a.updatedAt) - new Date(b.updatedAt); });
          let filteredHistories = sortedHistories.filter(h => h.archived === false );

          if (filteredHistories.length == 0) {
            return 0;
          } else {
            return filteredHistories[filteredHistories.length - 1].gaps.length;
          }
        }
      },
      filterTable() {
        if (this.filterAgencies == null && this.filterManagers == null && this.filterStatus == null) {
          this.filteredSlices = this.slices;
        }

        if (this.filterAgencies != null && this.filterManagers == null && this.filterStatus == null) {
          this.filteredSlices = this.slices.filter((item) => {
            return item.agency.id == this.filterAgencies;
          });
        }

        if (this.filterAgencies != null && this.filterManagers != null && this.filterStatus == null) {
          this.filteredSlices = this.slices.filter((item) => {
            return (item.agency.id == this.filterAgencies && item.caseManager.id == this.filterManagers);
          });
        }

        if (this.filterAgencies == null && this.filterManagers != null && this.filterStatus == null) {
          this.filteredSlices = this.slices.filter((item) => {
            return (item.caseManager.id == this.filterManagers);
          });
        }

        if (this.filterAgencies == null && this.filterManagers == null && this.filterStatus != null) {
          if (this.filterStatus == 'open') {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.completeDate == null)
            });
          } else {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.completeDate != null)
            });
          }
        }

        if (this.filterAgencies != null && this.filterManagers != null && this.filterStatus != null) {
          if (this.filterStatus == 'open') {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.agency.id == this.filterAgencies && item.caseManager.id == this.filterManagers && item.completeDate == null)
            });
          } else {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.agency.id == this.filterAgencies && item.caseManager.id == this.filterManagers && item.completeDate != null)
            });
          }
        }

        if (this.filterAgencies != null && this.filterManagers == null && this.filterStatus != null) {
          if (this.filterStatus == 'open') {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.agency.id == this.filterAgencies && item.completeDate == null)
            });
          } else {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.agency.id == this.filterAgencies && item.completeDate != null)
            });
          }
        }

        if (this.filterAgencies == null && this.filterManagers != null && this.filterStatus != null) {
          if (this.filterStatus == 'open') {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.caseManager.id == this.filterManagers && item.completeDate == null)
            });
          } else {
            this.filteredSlices = this.slices.filter((item) => {
              return (item.caseManager.id == this.filterManagers && item.completeDate != null)
            });
          }
        }
      },
      resetFilters() {
        this.filterAgencies = null;
        this.filterManagers = null;
        this.filterStatus = 'open';
      },
      getStatusClass(val) {
        if (val == null) {
          return 'ongoing';
        } else {
          return 'filled';
        }
      },
      formatStatusText(val) {
        if (val == null) {
          return 'En cours';
        } else {
          return 'Complet';
        }
      }
    },
    mounted() {
      this.getMe();
      this.ready = false;
      this.isBusy = true;

      // Checking if agencies are in the Store. If not, fetch and store them
      if (this.getAgencies().length == 0) {
        this.$store.dispatch('fetchAgencies').then(() => { this.agencies = this.getAgencies(); });
      } else {
        this.agencies = this.getAgencies();
      }

      axios.get('tranches')
        .then((response) => {
          this.slices = _.filter(response.data, function(o) { return (!o.isArchived && !o.enedisCase.archived)});
          this.ready = true;
        })
        .catch((error) => {
          console.error(error.message);
        })
        .finally(() => {
          this.isBusy = false;
          this.filterTable();
        });

      axios.get('case-managers')
          .then((response) => {
            let managers = response.data;

            managers.forEach((item, index) => {
              this.managers.push({
                value: item.id,
                text: item.firstName + ' ' + item.name
              });
            });
          });
    },
    computed: {
      fields() {
        // Get the viewport type (xs,sm,md,lg,xl)
        const viewPortSize = this.getViewPortSize();
        // Fields table
        const computedFields = [
          {
            key: 'enedisCaseId',
            label: 'Affaire',
            formatter: (value, key, item) => {
              return item.enedisCase.oasiceNumber;
            },
            sortable: true,
          },
          {
            key: 'caseManager',
            label: 'Chargé d\'affaire',
            formatter: (value, key, item) => {
              return item.caseManager.firstName + ' ' + item.caseManager.name;
            },
            filterByFormatted: (value, key, item) => {
              return item.caseManager.name;
            },
            sortable: true,
          },
          {
            key: 'agency',
            label: 'Agence',
            formatter: (value, key, item) => {
              return item.agency.type + ' - ' + item.agency.name;
            },
            sortable: true,
          },
          { key: 'ameoDate',
            label: 'Date AMEO',
            formatter: (value, key, item) => {
              return this.formatDate(item.ameoDate)
            },
            sortByFormatted: false,
            sortable: true,
          },
          {
            key: 'receptionDate',
            label: 'Date de réception',
            formatter: (value, key, item) => {
              if (value == null) {
                return null;
              } else {
                return this.formatDate(item.receptionDate)
              }
            },
            sortByFormatted: false,
            sortable: true,
          },
          {
            key: 'completeDate',
            label: 'Date de complétude',
            formatter: (value, key, item) => {
              if (value == null) {
                return null;
              } else {
                return this.formatDate(item.completeDate)
              }
            },
            sortByFormatted: false,
            sortable: true,
          },
          { key: 'gaps',
            label: 'Aléas',
            formatter: (value, key, item) => {
                return this.getNumberOfGaps(item.gapHistories)
            },
            sortable: true,
          },
          {
            key: 'status',
            label: 'Statut',
            sortable: true
          },
          {
            key: 'progress',
            label: 'Délai écoulé',
            formatter: (value, key, item) => {
              let delay = TrancheService.getProgressData(item);

              return delay.days;
            },
            sortable: true,
          },
        ];
        // According to the size, some fields are deleted to make the table responsive
        if (viewPortSize === 'xs') {
          delete computedFields.agent;
        } else if (viewPortSize === 'sm') {
          // delete computedFields.?;
        } else if (viewPortSize === 'md') {
          // delete computedFields.?;
        } else if (viewPortSize === 'lg') {
          // delete computedFields.?;
        }
        return computedFields;
      },
      rows() {
        return this.filteredSlices.length;
      }
    },
    watch: {
      agencies(newVal) {
        newVal.forEach((item, index) => {
          this.formattedAgencies.push({ value: item.id, text: item.type + ' - ' + item.name });
        });
      },
      filterAgencies(newVal) {
        this.filterTable();
      },
      filterManagers(newVal) {
        this.filterTable();
      },
      filterStatus(newVal) {
        this.filterTable();
      },
      slices(newVal) {
        this.filteredSlices = newVal;
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#picto-filter {
  width: 27px;
}

.filter {
  background-color: #fff;
  padding: 15px 30px;
  border-radius: 3px;
  margin-top: 35px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .group {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
  }

  label {
    margin-left: 30px;
    margin-right: 10px;
    margin-bottom: 0;
  }

  @media screen and (max-width: 1600px) {
    label {
      margin: 0 0 10px 0;
    }
    .group {
      flex-direction: column;
    }
  }

  @media screen and (max-width: 1270px) {
    flex-direction: column;

    #picto-filter {
      display: none;
    }

    label,
    .mr-sm-2 {
      margin: 0 0 5px 0 !important;
    }

    .group {
      margin-bottom: 20px;

      &:first-child {
        margin: 0;
      }
    }

    #filterResetBtn {
      margin: 0;
    }
  }
}

#filterResetBtn {
  background-color: #005EB8;
  border-color: #005EB8;
  padding: 8px 25px;
  margin-left: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  #picto-reset {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    -webkit-mask: url('/static/img/reset.svg') no-repeat center;
    mask: url('/static/img/reset.svg') no-repeat center;
    background-color: white;
    display: inline-block;
  }

  &:hover {
    background-color: #fff;
    color: #005EB8;

    #picto-reset {
      background-color: #005EB8;
    }
  }
}

.table {
  td {
    .case-link {
      font-weight: bold;
      color: inherit;
    }
  }
}

#pagination {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/Dashboard.vue